export const getComMethods = (state) => {
	return state.Session.ab_com_methods;
};
